export default {"src":"/_next/static/media/check_mark.02cca850.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};